import React from "react";
import { Box, Typography } from "@mui/material";
import Div from "@jumbo/shared/Div";
import { useLocation } from "react-router-dom";



const Footer = () => {

    const location = useLocation();

    const footerStyle = {
        py: 2,
        px: { lg: 6, xs: 2 },
        bgcolor: 'background.paper',
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 500
    }

    return (

        // reduced px by 2 on xs
        <Box sx={footerStyle}>

            {!location.pathname.startsWith("/superadmin") ?

                // add margin to image and fixed image width
                ((<Div sx={{ display: 'flex', justifyContent: "center", alignItems: 'center' }}>
                    <Typography variant={"body1"} color={"text.primary"} sx={{ display: 'flex', justifyContent: "center", alignItems: 'center' }}>
                        <img src={`/images/logo.png`} alt="Trexo Global" style={{
                            width: !location.pathname.includes("/trexo-chat") ? "300px" : "200px",
                            height: "auto",
                            marginLeft: "8px",
                            paddingBottom: "12px"
                        }}

                        />
                    </Typography>
                </Div>))
                :
                (
                    (<Div sx={{ display: 'flex', justifyContent: "center", alignItems: 'center' }}>
                        <Typography variant={"body1"} color={"text.primary"}>Copyright Trexo Global © 2022</Typography>
                    </Div>)
                )
            }



        </Box>
    );
};

export default Footer;